import ShowView from './ShowView.vue';
import ListView from './ListView.vue';

export default { ShowView, ListView };